// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__2uh1H","expandIcon":"AccordionButton_expandIcon__12z-R","expanded":"AccordionButton_expanded__1epJN"};